import * as React from "react";
import type { SVGProps } from "react";
const SvgPlaceholder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.05 2.19a10.043 10.043 0 0 1 3.9 0 1 1 0 1 1-.388 1.962 8.044 8.044 0 0 0-3.124 0 1 1 0 1 1-.389-1.962Zm6.12 1.77a1 1 0 0 1 1.387-.275 10.05 10.05 0 0 1 2.758 2.758 1 1 0 0 1-1.662 1.113 8.048 8.048 0 0 0-2.209-2.21 1 1 0 0 1-.274-1.386Zm-8.34 0a1 1 0 0 1-.274 1.387 8.05 8.05 0 0 0-2.21 2.209 1 1 0 0 1-1.661-1.113 10.05 10.05 0 0 1 2.758-2.758 1 1 0 0 1 1.387.275ZM3.365 9.263a1 1 0 0 1 .787 1.175 8.044 8.044 0 0 0 0 3.124 1 1 0 1 1-1.962.389 10.043 10.043 0 0 1 0-3.902 1 1 0 0 1 1.175-.786Zm17.27 0a1 1 0 0 1 1.175.787 10.048 10.048 0 0 1 0 3.9 1 1 0 0 1-1.962-.388 8.044 8.044 0 0 0 0-3.124 1 1 0 0 1 .787-1.175Zm-.595 6.907a1 1 0 0 1 .275 1.387 10.052 10.052 0 0 1-2.758 2.758 1 1 0 0 1-1.113-1.662 8.046 8.046 0 0 0 2.21-2.209 1 1 0 0 1 1.386-.274Zm-16.08 0a1 1 0 0 1 1.387.274 8.048 8.048 0 0 0 2.209 2.21 1 1 0 0 1-1.113 1.661 10.05 10.05 0 0 1-2.758-2.758 1 1 0 0 1 .275-1.387Zm5.303 4.465a1 1 0 0 1 1.175-.787 8.044 8.044 0 0 0 3.124 0 1 1 0 1 1 .389 1.962 10.048 10.048 0 0 1-3.902 0 1 1 0 0 1-.786-1.175Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPlaceholder;
